import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"
import Navigator from "./navigator/reducer"
import Dashboard from "./dashboard/reducer"
import areasArmazenamento from "./areasArmazenamento/reducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  areasArmazenamento,
  ForgetPassword,
  Profile,
  Navigator,
  Dashboard
})

export default rootReducer
